import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import formatDate from '../utilities/FormatDate'

import Layout from '../components/Layout/index'
import Section from '../components/Section/index'
import SubHeader from '../components/SubHeader/index'
import BlogList from '../components/BlogList/index'
import BlogPost from '../components/BlogPost/index'

import ImageShareFB from '../assets/images/header-optimised.jpeg'

const BlogSinglePage = ({ data: { contentfulBlogPost } }) => {
  const { title, date, description, related } = contentfulBlogPost
  const body = contentfulBlogPost.body.childMarkdownRemark.html
  const relatedBlogPosts = related.map(blogPost => ({
    id: blogPost.id,
    title: blogPost.title,
    date: blogPost.date,
    link: `blogi/${blogPost.title.replace(/ /gi, '-').replace(/[,]/gi, '')}`,
  }))

  return (
    <Layout>
      {
        <>
          {contentfulBlogPost ? (
            <Helmet>
              <meta property="og:title" content={contentfulBlogPost.title} />
              <meta
                name="og:image"
                property="og:image"
                content={ImageShareFB}
              />
              <meta
                name="og:description"
                property="og:description"
                content={description}
              />
              <meta name="twitter:title" content={contentfulBlogPost.title} />
              <meta name="twitter:description" content={description} />
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:image" content={ImageShareFB} />
              <meta
                name="twitter:image:src"
                content="https://danielrahman.com/static/header-optimised-6d143c28f915829e5f248e97eb8dcb1f.jpeg"
              />
            </Helmet>
          ) : (
            ''
          )}
          <Section variant="header">
            <SubHeader heading={title} backgroundImg date={formatDate(date)} />
          </Section>
          <Section variant="narrow">
            <BlogPost data={body} />
            <BlogList data={relatedBlogPosts} wrapper />
          </Section>
        </>
      }
    </Layout>
  )
}

export default BlogSinglePage

BlogSinglePage.propTypes = {
  data: PropTypes.objectOf(PropTypes.objectOf(PropTypes.any).isRequired)
    .isRequired,
}

export const query = graphql`
  query($slug: String!) {
    contentfulBlogPost(id: { eq: $slug }) {
      title
      date
      description
      body {
        childMarkdownRemark {
          html
        }
      }
      related {
        id
        title
        date
      }
    }
  }
`
